<template>
    <div class="div">
        <google-map :polylines="polylines" :markers="markers">
        </google-map>
    </div>
</template>
<script>
import GoogleMap from '@/components/Map.vue'
import { stageTypeMarkerIcon } from '@/store/mapOptions'
import { mapGetters } from 'vuex'

export default {
    props: ['stage'],
    components: {
        GoogleMap,
    },
    computed: {
        ...mapGetters([
            'getMapIconByTransportMode',
        ]),
        polylines() {
            return [this.stage.polyline]
        },
        markers() {
            return [
                {
                    position: this.stage.start_location,
                    icon: {
                        ...stageTypeMarkerIcon,
                        url: this.getMapIconByTransportMode(this.stage.type),
                    },
                },
            ]
        },
    },
}
</script>
